<template>
  <v-container fluid id="container">
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <img id="tos-text-img" justify="center" :src="img_src">
      </v-col>
    </v-row>
    <v-row v-if="typeof askUser !== 'undefined'" justify="center" no-gutters>
      <v-col cols="auto" class=agree-btn>
        <button @click="$emit('click-agree-button')">
          <span class='title'>{{agree_txt}}</span>
        </button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Terms',
  props: ['askUser'],
  computed: {
    img_src() {
      if (this.$store.state.lang == 'jp') {
        return require('@/assets/tos_jp.png');
      } else {
        return require('@/assets/tos_en.png');
      }
    },
    agree_txt() {
      if (this.$store.state.lang == 'jp') {
        return "同意します";
      } else {
        return "AGREE";
      }
    }
  }
}
</script>

<style scoped>
#container {
  padding: 0;
  background-color: #ff0000;
}

#tos-text-img {
  width: 100%;
}

.agree-btn {
  margin: 25px;
}
</style>
